<form #policyRuleForm="ngForm" (ngSubmit)="policyRuleForm.valid && close()">
    <div class="mon-dialog-body-with-footer auto-scroll policy-form-dialogs-rule px-3">
        <div class="row">
            <div class="col-48 mt-4">
                <div class="form-group" [ngClass]="{'has-error': policyRuleForm.form.get('name')?.invalid && (policyRuleForm.form.get('name')?.dirty || policyRuleForm.submitted )}">
                    <label class="col-form-label text-bold"><span translate>Rule name</span>*</label>
                    <div>
                        <form-field-input name="name" [(ngModel)]="cRule.name" [required]="true"></form-field-input>
                        <form-field-errors [input]="policyRuleForm.form.get('name')" offset="0"></form-field-errors>
                    </div>
                </div>
            </div>

            <div class="col-48 mt-2">
                <div class="form-group" [ngClass]="{'has-error': policyRuleForm.form.get('query')?.invalid && (policyRuleForm.form.get('query')?.dirty || policyRuleForm.submitted )}">
                    <label for="query" class="col-form-label text-bold" translate>Search for image size that is</label>:
                    <div class="input-group">
                        <mon-action-menu
                            class="rule-menu-action"
                            *ngIf="cRule.operator"
                            [monActionMenuItems]="imageSizeTypeDropdownOptions"
                            [monActionMenuClass]="'menu-panel-left-align'"
                            >{{selectedOperator?.translation}}</mon-action-menu>

                        <input name="query"
                               data-test="query-starts-with"
                               [required]="true"
                               [(ngModel)]="cRule.query"
                               #queryFormControl="ngModel"
                               id="query"
                               type="number"
                               [min]="0"
                               class="form-control" />

                        <mon-action-menu
                            class="rule-menu-action"
                            [monActionMenuItems]="imageSizeDropdownSizeOptions"
                            >{{selectedSize?.name}}</mon-action-menu>
                    </div>
                    <div class="form-text text-muted" translate>
                        Define size of images to look for
                    </div>
                    <form-field-errors [input]="queryFormControl" offset="0"></form-field-errors>
                </div>
            </div>
        </div>
    </div>
    <div class="mon-dialog-footer text-right">
        <button data-test="save-button"
                class="btn btn-border-radius btn-secondary"
                type="submit"
                [disabled]="policyRuleForm.invalid"
                translate>
            Save
        </button>
    </div>
</form>
